
    <form [formGroup]="editForm"  class="k-form-inline">

      <div class="k-form-field">
        <label class="form-label col-3 k-label" for="student_institution_id"> Student Institution ID</label>
        <div class="col-8">
          <input type="text" id="student_institution_id" formControlName="student_institution_id" class="form-control" [readonly]="true">
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3 k-label" for="student_email"> Student Email</label>
        <div class="col-8">
          <input type="text" id="student_email" formControlName="student_email" class="form-control" [readonly]="true">
        </div>
      </div>
      <hr>
      <div class="k-form-field">
        <label class="form-label col-3 k-label" for="placement_location"> Placement Location</label>
        <div class="col-8">
          <input type="text" id="placement_location" formControlName="placement_location" class="form-control" appAutoFocus>
          <div *ngIf="placement_location?.invalid" class="alert alert-danger">
            <div *ngIf="placement_location?.errors?.['required']">Placement Location is required.</div>
          </div>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3 k-label" for="supervisor_user_id">Primary Supervisor</label>
        <div class="col-8">
          <kendo-dropdownlist id="supervisor_user_id" formControlName="supervisor_user_id"
                              [data]="supervisorDs" [valuePrimitive]="true"
                              textField="display_name" valueField="id"
                              [defaultItem]="{ id: null, display_name: 'Select...' }" >
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              {{ dataItem.display_name }}
              <ng-container *ngIf="dataItem?.email"> ({{ dataItem.email }})</ng-container>
            </ng-template>

            <ng-template kendoDropDownListValueTemplate let-dataItem>
              {{ dataItem?.display_name }} <ng-container *ngIf="dataItem?.email">({{ dataItem?.email }})</ng-container>
            </ng-template>
          </kendo-dropdownlist>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3 k-label" for="additional_supervisor_user_id">Secondary Supervisor</label>
        <div class="col-8">
          <kendo-dropdownlist id="additional_supervisor_user_id" formControlName="additional_supervisor_user_id"
                              [data]="additionalSupervisorDs" [valuePrimitive]="true"
                              textField="display_name" valueField="id"
                              [defaultItem]="{ id: null, display_name: 'Select...' }" >
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              {{ dataItem.display_name }}
              <ng-container *ngIf="dataItem?.email"> ({{ dataItem.email }})</ng-container>
            </ng-template>

            <ng-template kendoDropDownListValueTemplate let-dataItem>
              {{ dataItem?.display_name }} <ng-container *ngIf="dataItem?.email">({{ dataItem?.email }})</ng-container>
            </ng-template>
          </kendo-dropdownlist>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3">Date Range</label>
        <div class="col-8" >
          <kendo-daterange>
            <kendo-label text="Start">
              <kendo-dateinput [format]="format" kendoDateRangeStartInput [(value)]="dateRange.start" formControlName="start"></kendo-dateinput>
            </kendo-label>
            <kendo-label text="End">
              <kendo-dateinput [format]="format" kendoDateRangeEndInput [(value)]="dateRange.end" formControlName="end"></kendo-dateinput>
            </kendo-label>
          </kendo-daterange>
          <div *ngIf="start?.invalid || end?.invalid" class="alert alert-danger">
            <div *ngIf="start?.errors?.['required'] || end?.errors?.['required']">Start and End Dates are required.</div>
          </div>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3 k-label" for="year_first_practice"> Year of first Registration</label>
        <div class="col-3 " style="margin-right: 10px">
            <input type="text"  id="year_first_practice"
                   inputmode="numeric"
                   pattern="[0-9]*"
                   maxlength="4"
                   formControlName="year_first_practice" class="form-control no-spinner"  step="1" style="text-align: center">

          <div *ngIf="year_first_practice?.invalid" class="alert alert-danger">
            <div *ngIf="year_first_practice?.errors?.['min'] || year_first_practice?.errors?.['max'] || year_first_practice?.errors?.['pattern']">
              Only years from 1971 to current year are allowed.
            </div>
          </div>
        </div>
        <label class="form-label col-5 k-label" for="year_first_practice"> Leave blank if you have not practiced professionally yet</label>
      </div>
    </form>

    <kendo-dialog-actions>
      <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="editForm.invalid">Save</button>
      <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
    </kendo-dialog-actions>
